import { render, staticRenderFns } from "./RestaurantItem.vue?vue&type=template&id=2621325c&scoped=true&"
import script from "./RestaurantItem.vue?vue&type=script&lang=js&"
export * from "./RestaurantItem.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantItem.vue?vue&type=style&index=0&id=2621325c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621325c",
  null
  
)

export default component.exports